import { api } from "@/lib/api";

export async function listFavorites() {
  try {
    const { data } = await api.get("/me/favorites");
    return data.items || [];
  } catch {
    return [];
  }
}

export async function addFavorite({ label, latitude, longitude, name, country }) {
  const { data } = await api.post("/me/favorites", { label, latitude, longitude, name, country });
  return data;
}

export async function removeFavorite(id) {
  const { data } = await api.delete(`/me/favorites/${id}`);
  return data.items || [];
}
